<template>
    <div>

        <!-- Cancel training button -->

        <button class="btn btn-white btn-sm mb-4"
            @click="cancelTraining"
            v-if="cancelTrainingPermission && (!registration_state || !registration_state.cancelled)"
        >
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">cancel</i>
            Cancel Training
        </button>

        <!-- Resume training button -->

        <button class="btn btn-white btn-sm mb-4"
            @click="resumeTraining"
            v-if="cancelTrainingPermission && registration_state && registration_state.cancelled"
        >
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">play_arrow</i>
            Resume Training
        </button>

        <!-- Table -->

        <trax-ui-card-icon-header class="mt-5" header-color="info" icon="list" title="Phases">
            <trax-ui-ajax-simple-table 
                :id="id" :header="header" :header-color="headerColor" :titles="titles"
                :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
            </trax-ui-ajax-simple-table>
        </trax-ui-card-icon-header>

        <!-- Flight hours modal -->

        <trax-ui-modal-plain-header :id="id+'-modal'" :bus="bus">
            <enac-atpl-dashboard-flight-hours :id="id" :bus="bus">
            </enac-atpl-dashboard-flight-hours>
        </trax-ui-modal-plain-header>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-registration-phases' },
            header: { default: 0 },
            headerColor: { default: 'info' },
            learnerId: null,
            titles: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                endpoint: app_url+'polaris/api/front/registrations/' + data.registration.id,
                endpointParams: {
                    accessors: ['phases']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learners/'+data.learner.id,
                registration: data.registration,
                aggregation_dashboard_routes: data.aggregation_dashboard_routes,
                cols: [
                    {width: '35px'},
                    {},
                    {class: 'text-center'},
                    {class: 'text-center'},
                    {class: 'text-center'},
                ],
                rows: [],
                phases : null,
                states : null,
                registration_state : null,
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-states', this.setStates);
        },
        
        mounted: function() {
            var that = this;

            $('#'+this.id+'-table tbody').on( 'click', 'button.flight-hours', function(event) {
                var phaseId = $(this).attr('data-id');
                var color = $(this).attr('data-color');
                var state = that.states[phaseId];
                if (!state || !state.flight_hours || !state.flight_hours.length) return;
                that.open(phaseId, state.flight_hours, color);
            });

        },

        updated: function() {
            $("#"+this.id+"-table .peity.donut").peity("donut");
        },
        
        computed: {

            cancelTrainingPermission() {
                return this.user.admin || this.user.permissions['dashboard.write-all']
                     || this.user.permissions['dashboard.write-mine-locations'] 
            }
        },

        methods: {

            cancelTraining() {
                var that = this;
                axios.post(this.endpoint_states + '/cancel')
                    .then(function (response) {
                        that.setRegistrationState(response.data.data);
                        that.bus.$emit(that.id+'-registration-state', response.data.data);
                    })
                    .catch(function (error) {
                    });
            },
        
            resumeTraining() {
                var that = this;
                axios.post(this.endpoint_states + '/resume')
                    .then(function (response) {
                        that.setRegistrationState(response.data.data);
                        that.bus.$emit(that.id+'-registration-state', response.data.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            setData(data) {
                this.phases = data.data.phases;
                if (this.states) this.updateRows();
            },

            setStates(data) {
                this.states = data.phases;
                if (this.phases) this.updateRows();
                this.setRegistrationState(data.registration);
            },

            setRegistrationState(state) {
                this.registration_state = state;
            },

            updateRows() {
                this.rows = [];
                for (var index in this.phases) {
                    var phase = this.phases[index];
                    this.rows.push([
                        this.num(phase, index),
                        this.name(phase),
                        this.status(phase),
                        this.trainingAlerts(phase),
                        this.flightHours(phase)
                    ]);
                }
            },

            num(phase, index) {
                var html = parseInt(index)+1;
                return this.link(phase, html);
            },

            open(phaseId, flightHours, color) {
                for (var index in this.phases) {
                    var phase = this.phases[index];
                    if (phase.id == phaseId) {
                        var data = { flight_hours: flightHours, location: this.location(phase)};
                        this.bus.$emit(this.id+'-modal-open', { headerColor: color, icon: 'flight', title: phase.name, data: data });
                        return;
                    }
                }
            },

            name(phase) {
                var html = phase.name;
                if (this.location(phase)) {
                    html += '<br><small>'+this.location(phase)+'</small>';
                }
                return this.link(phase, html);
            },

            location(phase) {
                if (phase.custom && phase.custom.location) {
                    return phase.custom.location.name
                } else if (phase.location) {
                    return phase.location.name
                } else {
                    return ''
                }
            },

            status(phase) {
                if (!this.states) return '';
                var state = this.states[phase.id];
                if (!state) return '';
                var html = '<div class="mt-1">';
                html += '<span class="peity donut" data-peity=\'{ "fill": ["#00acc1", "#eeeeee"], "innerRadius": 10, "radius": 12 }\'>';
                html += state.completion.percent + '/100</span>';
                html += '<small class="ml-1">'+state.completion.percent+'%</small>';
                html += '</div>';
                return this.link(phase, html);
            },

            trainingAlerts(phase) {
                if (!this.states) return '';
                var state = this.states[phase.id];
                if (!state || !state.training_alerts) return '';
                var html = '<i class="material-icons text-danger">report_problem</i>';
                return this.link(phase, html);
            },

            flightHours(phase) {
                if (!this.states) return '';
                var state = this.states[phase.id];
                if (!state || !state.flight_hours || !state.flight_hours.length) return '';

                // Parse hours
                var color = 'success';
                var hours = 0;
                for (var index in state.flight_hours) {
                    var category = state.flight_hours[index];
                    if (typeof category.global !== "undefined") {
                        category = category.global;
                    }
                    if (category.key == 'total') {
                        hours = category.time_spent;
                    } else if (category.display && category.time_spent < category.duration) {
                        color = 'danger';
                    } 
                }

                // HTML
                var html = '';
                html += '<button class="flight-hours btn btn-sm btn-link pr-1 pl-1 btn-'+color+'" data-id="'+phase.id+'" data-color="'+color+'">';
                html += '   <i class="material-icons">flight</i> ';
                html +=     hours+'H';
                html += '</button>';
                return html;
            },

            link(phase, content) {
                var routes = this.aggregation_dashboard_routes;
                var href = routes[phase.type]+'/registration/'+this.registration.id+'/'+phase.type+'/'+phase.id;
                if (this.learnerId) href += '/learner/'+this.learnerId;
                return '<a href="'+href+'">'+content+'</a>';
            }

        }

    }
</script>
